import { render } from "./SettingWysiwygEditor.vue?vue&type=template&id=1dc36b6c"
import script from "./SettingWysiwygEditor.vue?vue&type=script&lang=js"
export * from "./SettingWysiwygEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__